import { Box } from "lucide-react";
import InventoryTable from "../components/InventoryTable";

export default function Packaging() {
  return (
    <InventoryTable section="packaging" icon={Box} title="Packaging" />
  );
}
